import React from 'react'
import Modal from 'react-responsive-modal'
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { ClickAwayListener }  from '@material-ui/core'

import "./ModalFrame.less"

// Por encima del sidesheet MUI y del z-index por defecto de react-responsive-modal (1000)
const Z_OVER_SIDE_SHEET_OVERLAY = 1400
const Z_OVER_SIDE_SHEET_MODAL = 1401

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#000D',
    maxWidth: 450,
  },
}))(Tooltip);

export default function ModalFrame(props) {
  const {
    open,
    height,
    width,
    maxWidth = 'auto',
    title,
    closeButton,
    onCloseModal,
    verticalCenter,
    tooltipIconHeader={
      active: false,
      icon: "help_outline",
      className: null,
      content: null,
    },
    subTitleHeader = "",
    spaceBetweenTitleAndCloseIcon,
    containerClass,
    showFrameHeader = true
  } = props

  const [openTooltip, setOpenTooltip] = React.useState(false);
  const handleTooltipClose = () => { setOpenTooltip(false); };
  const handleTooltipOpen = () => { setOpenTooltip(true);};

  //open(boolean): Abre o Cierra el modals
  //closeButton(boolean): Muestra el boton para cerrar modal en la esquina superior derecha
  //onCloseModal(function): Recibe funcion que cambia el estado del modal en el componente que lo llama  
  //title(string): Titulo superior del modal
  //children: El body completo del modal es pasado por children, ya sean textos, imagenes, botones, etc.

  return (
    <Modal
      open={open}
      focusTrapped={false}
      onClose={()=>{}}
      showCloseIcon={false}
      center={verticalCenter}
      styles={{
        overlay: { zIndex: Z_OVER_SIDE_SHEET_OVERLAY },
        modal: {
          zIndex: Z_OVER_SIDE_SHEET_MODAL,
          minWidth: width,
          maxWidth: maxWidth,
          padding: 0,
          borderRadius: 10,
          marginTop: '5%',
          ...props.style,
        },
      }}
    >
      <div className={`'modal-frame' ${containerClass ? containerClass : null}`}>
        { showFrameHeader && <div className="modal-frame_header">
          <div className='d-flex flex-column tst-mf'>
            <div className='d-flex'>
              {title}
              {tooltipIconHeader.active && ( 
                <ClickAwayListener onClickAway={handleTooltipClose}>
                  <div className={tooltipIconHeader.className}>
                    <HtmlTooltip
                      placement="right" 
                      arrow 
                      title={ tooltipIconHeader.content }
                      PopperProps={{
                        disablePortal: true,
                      }}
                      onClose={handleTooltipClose}
                      open={openTooltip}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                    >
                      <i className="material-icons ih-tooltip" onClick={handleTooltipOpen}>{tooltipIconHeader.icon}</i> 
                    </HtmlTooltip>
                  </div>
                </ClickAwayListener>
              )}
            </div>
            {subTitleHeader && ( 
              <span className="sth-mf ">{subTitleHeader}</span>
            )}

          </div>
          {closeButton && (<i className="material-icons icon-close" style={{paddingLeft: spaceBetweenTitleAndCloseIcon}} onClick={onCloseModal}>
            clear
          </i>)}
        </div>
        }
        <div className="modal-frame_body" style={{ minHeight: height }}>
          {props.children}
        </div>
      </div>
    </Modal>
  )
}
